<template>
  <button 
    type="button" 
    class="btn btn-sm d-flex align-items-center justify-content-center" 
    :class="modelValue ? 'btn-outline-danger' : 'btn-outline-success'"
    :title="modelValue ? 'Include Locked Records' : 'Unlocked Records Only'"
    v-tooltip 
    @click="toggleLockedFilter" 
    style="width: 32px; height: 32px; border-radius: 4px;"
  >
    <i class="bi" :class="modelValue ? 'bi-lock-fill' : 'bi-unlock-fill'" style="font-size: 1.15rem;"></i>
  </button>

</template>

<script setup>

const modelValue = defineModel({ type: Boolean, default: false });

const props = defineProps({
  activeTitle: { type: String, default: 'Include Locked Records' },
  inactiveTitle: { type: String, default: 'Unlocked Records Only' }
});

const emit = defineEmits(['toggle']);

const toggleLockedFilter = () => {
  console.debug(`Toggling locked filter from ${modelValue.value}`);
  modelValue.value = !modelValue.value;
  // Emit a generic toggle action event so parents can kick off API/Table reloads
  emit('toggle', modelValue.value);
};

</script>